import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { WorkspaceDistribution } from '../types/reference-filter';
import { SettingsService } from '@core/services/settings/settings.service';

@Injectable({
	providedIn: 'root',
})
export class FiltersService {
	private apiWeightBalanceUrl = null;

	constructor(private http: HttpClient, private settingsService: SettingsService) {
		settingsService.general.applicationConfig$.subscribe(config => {
			this.apiWeightBalanceUrl = config.apiWeightBalanceURL;
		});
	}

	httpOptions = {
		headers: new HttpHeaders({
			'Content-Type': 'application/json',
		}),
	};

	getFilters(): Promise<WorkspaceDistribution[]> {
		return this.http
			.get<WorkspaceDistribution[]>(this.apiWeightBalanceUrl + '/admin/filters')
			.pipe(retry(1), catchError(this.handleError))
			.toPromise();
	}

	getFilter(id: number): Promise<WorkspaceDistribution> {
		return this.http
			.get<WorkspaceDistribution>(this.apiWeightBalanceUrl + '/admin/filters/' + id)
			.pipe(retry(1), catchError(this.handleError))
			.toPromise();
	}

	addFilter(filter: WorkspaceDistribution): Promise<WorkspaceDistribution> {
		return this.http
			.post<WorkspaceDistribution>(
				this.apiWeightBalanceUrl + '/admin/filters',
				JSON.stringify(filter),
				this.httpOptions
			)
			.pipe(retry(1), catchError(this.handleError))
			.toPromise();
	}

	saveFilter(id: number, filter: WorkspaceDistribution): Promise<WorkspaceDistribution> {
		return this.http
			.put<WorkspaceDistribution>(
				this.apiWeightBalanceUrl + '/admin/filters/' + id,
				JSON.stringify(filter),
				this.httpOptions
			)
			.pipe(retry(1), catchError(this.handleError))
			.toPromise();
	}

	deleteFilter(id: number): Promise<WorkspaceDistribution> {
		return this.http
			.delete<WorkspaceDistribution>(this.apiWeightBalanceUrl + '/admin/filters/' + id)
			.pipe(retry(1), catchError(this.handleError))
			.toPromise();
	}

	handleError(error) {
		let errorMessage = '';
		if (error.error instanceof ErrorEvent) {
			// Get client-side error
			errorMessage = error.error.message;
		} else {
			// Get server-side error
			errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
		}
		window.alert(errorMessage);
		return throwError(error.error);
	}
}
